import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { createStytchHeadlessClient } from '@stytch/nextjs/headless';
import { AuthError, AuthErrorCodes } from './error';
var hasURLSearchParams = typeof window !== 'undefined' && typeof URLSearchParams !== 'undefined';
/**
 * The `StytchClient` is a Chord compatabile wrapper around the following Stytch
 * libraries.
 *
 * - [@stytch/nextjs](https://www.npmjs.com/package/@stytch/nextjs)
 * - [@stytch/vanilla-js](https://www.npmjs.com/package/@stytch/vanilla-js)
 *
 * @example
 *
 * ```javascript
 * import StytchClient from '@chordcommerce/chord-stytch'
 * const stytchClient = new StytchClient({
 *   apiKey: process.env.STYTCH_API_KEY,
 *   redirectPath: '/authenticate',
 *   sessionDurationMinutes: 60,
 * })
 * ```
 */
var StytchClient = /*#__PURE__*/function () {
  function StytchClient(options) {
    var _options$redirectPath, _options$sessionDurat;
    _classCallCheck(this, StytchClient);
    _defineProperty(this, "client", void 0);
    _defineProperty(this, "redirectPath", void 0);
    _defineProperty(this, "sessionDurationMinutes", void 0);
    if (!options.apiKey) {
      throw new AuthError({
        message: 'An API key is required',
        code: AuthErrorCodes.MissingApiKey
      });
    }
    this.redirectPath = (_options$redirectPath = options.redirectPath) !== null && _options$redirectPath !== void 0 ? _options$redirectPath : '/authenticate';
    this.sessionDurationMinutes = (_options$sessionDurat = options.sessionDurationMinutes) !== null && _options$sessionDurat !== void 0 ? _options$sessionDurat : 60;
    if (typeof window === 'undefined') return;
    this.client = createStytchHeadlessClient(options.apiKey);
  }
  _createClass(StytchClient, [{
    key: "pollLoginStatus",
    value: function () {
      var _pollLoginStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this = this;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new Promise(function (resolve) {
                var intervalID = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var user;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this.getUser();
                      case 2:
                        user = _context.sent;
                        if (user) {
                          clearInterval(intervalID);
                          resolve(user);
                        }
                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                })), 1000);
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function pollLoginStatus() {
        return _pollLoginStatus.apply(this, arguments);
      }
      return pollLoginStatus;
    }()
  }, {
    key: "getToken",
    value: function () {
      var _getToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _tokens;
        var tokens;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              tokens = null;
              _context3.prev = 1;
              tokens = this.client.session.getTokens();
              _context3.next = 8;
              break;
            case 5:
              _context3.prev = 5;
              _context3.t0 = _context3["catch"](1);
              throw new AuthError({
                message: _context3.t0.message,
                code: AuthErrorCodes.InternalError
              });
            case 8:
              if (tokens) {
                _context3.next = 10;
                break;
              }
              throw new AuthError({
                message: 'User is not logged in',
                code: AuthErrorCodes.Unauthorized
              });
            case 10:
              return _context3.abrupt("return", (_tokens = tokens) === null || _tokens === void 0 ? void 0 : _tokens.session_token);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 5]]);
      }));
      function getToken() {
        return _getToken.apply(this, arguments);
      }
      return getToken;
    }()
  }, {
    key: "getUser",
    value: function getUser() {
      var _this$client;
      return (_this$client = this.client) === null || _this$client === void 0 ? void 0 : _this$client.user.get();
    }
  }, {
    key: "isLoggedIn",
    value: function isLoggedIn() {
      var _this$client2;
      return ((_this$client2 = this.client) === null || _this$client2 === void 0 ? void 0 : _this$client2.session.getSync()) !== null;
    }
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref2) {
        var _this$client3;
        var email;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              email = _ref2.email;
              _context4.next = 3;
              return (_this$client3 = this.client) === null || _this$client3 === void 0 ? void 0 : _this$client3.magicLinks.email.loginOrCreate(email, {
                login_magic_link_url: window.location.origin + this.redirectPath,
                signup_magic_link_url: window.location.origin + this.redirectPath
              });
            case 3:
              return _context4.abrupt("return", this.pollLoginStatus());
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function login(_x) {
        return _login.apply(this, arguments);
      }
      return login;
    }()
  }, {
    key: "logout",
    value: function logout() {
      return this.client.session.revoke();
    }
  }, {
    key: "handleCallback",
    value: function () {
      var _handleCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var params, token, type, _resp, resp;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              params = new URLSearchParams(window.location.search);
              token = params.get('token');
              type = params.get('stytch_token_type');
              if (!(!token || !type)) {
                _context5.next = 5;
                break;
              }
              throw new AuthError({
                message: 'In order to handleCallback, token and stytch_token_type must be in the query parameters',
                code: AuthErrorCodes.Unauthorized
              });
            case 5:
              if (!(type === 'oauth')) {
                _context5.next = 10;
                break;
              }
              _context5.next = 8;
              return this.client.oauth.authenticate(token, {
                session_duration_minutes: this.sessionDurationMinutes
              });
            case 8:
              _resp = _context5.sent;
              return _context5.abrupt("return", _resp.session_token);
            case 10:
              _context5.next = 12;
              return this.client.magicLinks.authenticate(token, {
                session_duration_minutes: this.sessionDurationMinutes
              });
            case 12:
              resp = _context5.sent;
              return _context5.abrupt("return", resp.session_token);
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function handleCallback() {
        return _handleCallback.apply(this, arguments);
      }
      return handleCallback;
    }()
  }, {
    key: "getServiceClient",
    value: function getServiceClient() {
      return this.client;
    }
  }, {
    key: "currentUrlHandlesCallback",
    value: function currentUrlHandlesCallback() {
      if (!hasURLSearchParams) {
        return false;
      }
      var params = new URLSearchParams(window.location.search);
      var token = params.get('token');
      var type = params.get('stytch_token_type');
      return token && type && window.location.pathname === this.redirectPath;
    }
  }]);
  return StytchClient;
}();
export default StytchClient;